import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ClientEspNdcImport } from '../models/client-esp-ndc-import.model';
import { LimitOffsetPagingMeta } from '../models/paged-results/limit-offset-paging.model';
import { PagedResults } from '../models/paged-results/paged-results.model';
import { ClientEspNdcImportFilters } from '../models/user-settings/client-esp-ndc-import-settings.model';

export class PagedClientEspNdcImports implements PagedResults {
  clientEspNdcImports: ClientEspNdcImport[];
  meta: LimitOffsetPagingMeta;

  get records() {
    return this.clientEspNdcImports;
  }
}

@Injectable()
export class ClientEspNdcImportsService extends ApiService {
  private http = inject(HttpClient);


  create(clientId: number, signedId: string): Observable<ClientEspNdcImport> {
    return this.http.post<ClientEspNdcImport>(`${environment.captureApi.url}/client_esp_ndc_imports`, {
      clientEspNdcImport: { clientId, signedId },
    });
  }

  getList(
    paging: { page: number; pageSize: number } = null,
    filters: ClientEspNdcImportFilters = null
  ): Observable<PagedClientEspNdcImports> {
    const params = new URLSearchParams();

    if (filters && filters.selectedClientIds) {
      filters.selectedClientIds.forEach(clientId => params.append('client_ids[]', clientId));
    }

    if (paging) {
      params.append('page', paging.page.toString());
      params.append('per_page', paging.pageSize.toString());
    }

    return this.http.get<PagedClientEspNdcImports>(
      `${environment.captureApi.url}/client_esp_ndc_imports?${params.toString()}`
    );
  }

  get(id): Observable<ClientEspNdcImport> {
    return this.http.get<ClientEspNdcImport>(`${environment.captureApi.url}/client_esp_ndc_imports/${id}`);
  }

  cancel(id): Observable<ClientEspNdcImport> {
    return this.http.patch<ClientEspNdcImport>(`${environment.captureApi.url}/client_esp_ndc_imports/${id}/cancel`, {});
  }
}